import styled from "styled-components";

export const SectionTitle = styled.h2`
  color: black;
  font-size: 1.8rem;
  font-weight: 700;
`;

export const Subtitle = styled.h2`
  color: ${({ theme }) => theme.colors.blackTextTitle};
  font-size: 1.4rem;
  font-weight: 600;
`;

export const RowBy2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const RowBy4 = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
`;

export const Container = styled.div`
  .react-date-picker {
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 8px;
    border: none;
    box-shadow: 0px 5px 20px rgba(231, 231, 234, 0.62);
    box-sizing: border-box;
    font-size: 1.5rem;
    font-weight: 500;
    height: 5rem;
    padding-left: 1.5rem;
    padding-right: 1rem;
    width: 25.6rem;
  }

  .react-date-picker__wrapper {
    border: none;
  }
`;

export const RadioContainer = styled.div`
  display: flex;
  label {
    ${({ theme }) => `
      color: ${theme.colors.blackTextBody};
    `}
    align-items: center;
    display: flex;
    font-size: 1.4rem;
    margin-right: 4rem;

    input {
      cursor: pointer;
      margin: 0 1rem 0 0;
    }
  }
`;

export const ClientSection = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
`;

export const AuxContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const GreenButton = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.accentGreen};
  border-radius: 1rem;
  cursor: pointer;
  display: flex;
  height: 6.2rem;
  justify-content: center;
  margin-top: 2rem;
  width: 43.1rem;
  h2 {
    color: ${({ theme }) => theme.colors.white};
    font-size: 1.6rem;
    font-weight: 700;
    margin-left: 1rem;
  }
  .icon {
    height: 5rem;
    width: 5rem;
  }
`;
